<template>
  <div
    v-incredi-focus-trap="'agent-loglevel'"
    class="assignment-priority"
  >
    <selector
      :values="values"
      @valueChanged="handleChange"
    ></selector>
  </div>
</template>

<script>
import selector from '../inputs/selector.vue';
import { notifyPresets } from './services/notifyPresets';

export default {
  name: 'LogLevel',
  components: {
    selector,
  },
  mixins: [notifyPresets],
  props: {
    selected: {},
    agentName: {},
    bulk: { default: false },
    agentsList: {},
  },
  emits: ['change'],
  data() {
    return {
      range: ['Minimal', 'Basic', 'Intermediate', 'Extended', 'Detailed'],
    };
  },
  computed: {
    values() {
      if (this.bulk) {
        const selections = [];

        // eslint-disable-next-line no-restricted-syntax
        for (const agent of this.agentsList) {
          if (!selections.includes(this.range[agent.LogLvl - 1])) selections.push(this.range[agent.LogLvl - 1]);
          if (selections.length > 1) break;
        }
        return {
          agentName: this.agentName,
          action: 'SetAgentLoggingLevel',
          min: 'Error',
          max: 'All',
          selected: null,
          range: this.range,
        };
      }
      return {
        agentName: this.agentName,
        action: 'SetAgentLoggingLevel',
        min: 'Error',
        max: 'All',
        selected: !Number.isNaN(this.selected) ? this.range[this.selected] : this.selected,
        range: this.range,
      };
    },
  },
  methods: {
    async handleChange(e) {
      this.$emit('change', e.value);
      // if (this.bulk) {
      //   const requestArr = [];
      //   this.agentsList.forEach(agent => {
      //     const promise = () =>
      //       this.$store.dispatch('agents/updateAgent', {
      //         action: this.values.action,
      //         agentName: agent.Name,
      //         value: e.value,
      //         agentObj: agent,
      //       });
      //     requestArr.push(promise);
      //   });
      //   this.postUpdateDialog(requestArr, 'LogLvl', this.range.indexOf(e.value));
      // } else {
      //   const result = await this.$store.dispatch('agents/updateAgent', { action: this.values.action, agentName: this.values.agentName, value: e.value });
      //   if (result.status === 'OK' || result.Status === 'OK') {
      //     this.notifyPresets.agentLogLevelSuccess();
      //   } else {
      //     this.notifyPresets.agentLogLevelFail();
      //   }
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.assignment-priority {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>
